export const STORE = "KUMUDU";
export const STORE_ID = 0;
